module.exports = __webpack_public_path__ + "img/摩天轮.908a3134.png";